import { Component, Inject, OnInit, HostListener, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-secure-pdf-viewer',
    templateUrl: './secure-pdf-viewer.component.html',
    styleUrls: ['./secure-pdf-viewer.component.scss']
})
export class SecurePdfViewerComponent implements OnInit {
    safeUrl: SafeResourceUrl | undefined;
    isNewTab: boolean = false;

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: { url: string; title?: string },
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        let url = '';
        let title = '';

        if (this.data) {
            url = this.data.url;
            title = this.data.title || 'View Document';
            this.isNewTab = false;
        } else {
            url = this.route.snapshot.queryParamMap.get('url') || '';
            title = this.route.snapshot.queryParamMap.get('title') || 'View Document';
            this.data = { url, title };
            this.isNewTab = true;
        }

        if (url) {
            // Append toolbar=0 to restrict UI in many browsers
            const secureUrl = `${url}#toolbar=0&navpanes=0&scrollbar=0`;
            this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(secureUrl);
        }
    }

    @HostListener('window:contextmenu', ['$event'])
    onContextMenu(event: MouseEvent) {
        event.preventDefault();
    }

    @HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Disable Ctrl+P (Print), Ctrl+S (Save), Ctrl+U (Source), Ctrl+Shift+I/J (Inspect)
        if (
            (event.ctrlKey && (event.key === 'p' || event.key === 's' || event.key === 'u' || event.key === 'P' || event.key === 'S' || event.key === 'U')) ||
            (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'i' || event.key === 'J' || event.key === 'j' || event.key === 'C' || event.key === 'c')) ||
            event.key === 'F12'
        ) {
            event.preventDefault();
            return false;
        }
        return true;
    }
}
